import { Chip } from '@mui/material'
import { PLACEHOLDER } from 'components/column-renderers'
import { TraineeStatus, TraineeStatusLabels } from 'types'

const STATUS_COLORS: Record<TraineeStatus, 'success' | 'warning' | 'default'> = {
  [TraineeStatus.PENDING]: 'warning',
  [TraineeStatus.ACTIVE]: 'success',
  [TraineeStatus.INACTIVE]: 'default',
}

export function TraineeStatusBadge({ status }: { status?: string | null }) {
  if (!status) {
    return <>{PLACEHOLDER}</>
  }

  const normalized = status.toUpperCase() as TraineeStatus
  const color = STATUS_COLORS[normalized]

  if (!color) {
    return <>{status}</>
  }

  return (
    <Chip label={TraineeStatusLabels[normalized]} color={color} size="small" variant="outlined" />
  )
}
